import apis from '@/utils/apis';

// 交易状态
const TRADE_STATUS = {
  // 未交易
  NOT_TRADED: {
    val: 0,
  },
  // 正在交易
  TRADING: {
    val: 1,
  },
  // 免收中
  FREEING: {
    val: 2,
  },
  // 待确认收款
  WAIT_CONFIRM_COLLECTION: {
    val: 6,
  },
  // 交易完成
  TRADE_FINISH: {
    val: 10,
  },
  // 交易拒绝
  TRADE_REJECT: {
    val: 90,
  },
  // 交易关闭
  TRADE_CLOSE: {
    val: 100,
  },
  // 已免收
  TRADE_FREE: {
    val: 11,
  },
};

// 开票情况
const BILL_STATUS = {
  // 待开票 1
  WAIT_INVOICE: {
    val: 0,
  },
  // 第一次开票 1
  HAS_INVOICE: {
    val: 1,
  },
  // 已冲红
  RED: {
    val: 2,
  },
  // 第二次开票
  SECOND: {
    val: 3,
  },
};

// 操作权限配置
const ACTION_AUTH = {
  // 付款登记
  PAY_REGISTER: {
    tradeStatus: [TRADE_STATUS.NOT_TRADED.val, TRADE_STATUS.TRADING.val],
    billStatus: [],
  },
  // 申请免收-应收
  APPLY_FREE: {
    tradeStatus: [TRADE_STATUS.NOT_TRADED.val],
    billStatus: [],
  },
  // 申请免收-应付
  APPLY_FREE_PAYMENT: {
    tradeStatus: [TRADE_STATUS.NOT_TRADED.val],
    billStatus: [],
  },
  // 查看付款记录
  CHECK_PAYMENT_INFO: {
    tradeStatus: [TRADE_STATUS.TRADE_FINISH.val],
    billStatus: [],
  },
  // 撤销付款
  CANCEL_PAYMENT: {
    tradeStatus: [TRADE_STATUS.WAIT_CONFIRM_COLLECTION.val],
    billStatus: [],
  },
  // 查看申请免收信息
  CHECK_APPLY_FREE_MSG: {
    tradeStatus: [TRADE_STATUS.TRADE_FREE.val],
    billStatus: [],
  },
  // 确认收款
  CONFIRM_COLLECTION: {
    tradeStatus: [TRADE_STATUS.WAIT_CONFIRM_COLLECTION.val],
    billStatus: [],
  },
  // 登记收款
  REGISTER_COLLECTION: {
    tradeStatus: [TRADE_STATUS.NOT_TRADED.val, TRADE_STATUS.TRADING.val],
    billStatus: [],
  },
  // 查看收款信息
  CHECK_COLLECTION_INFO: {
    tradeStatus: [TRADE_STATUS.TRADE_FINISH.val],
    billStatus: [],
  },
  // 撤销免收
  CANCEL_FREE: {
    tradeStatus: [TRADE_STATUS.TRADE_FREE.val],
    billStatus: [],
  },
  // 撤销收款
  CANCEL_COLLECTION: {
    tradeStatus: [TRADE_STATUS.TRADE_FINISH.val],
    billStatus: [],
  },
  // 延期收款
  DELAY_COLLECTION: {
    tradeStatus: [TRADE_STATUS.NOT_TRADED.val],
    billStatus: [],
  },
  // 延期付款
  DELAY_PAYMENT: {
    tradeStatus: [TRADE_STATUS.NOT_TRADED.val],
    billStatus: [],
  },
  // 拒绝收款
  REJECT_COLLECTION: {
    tradeStatus: [TRADE_STATUS.WAIT_CONFIRM_COLLECTION.val],
    billStatus: [],
  },
  // 取消订单
  CANCEL_ORDER: {
    tradeStatus: [TRADE_STATUS.TRADING.val, TRADE_STATUS.TRADE_REJECT.val],
    billStatus: [],
  },
};

const getDefault = function (name, defaultValue) {
  let result = defaultValue;
  try {
    if (localStorage.getItem(name)) {
      result = JSON.parse(localStorage.getItem(name));
    }
    return result;
  } catch (e) {
    return result;
  }
};

// 判断是否都是同一个付款公司
function isSamePaymentOrg(arr) {
  const map = {};
  arr.forEach((item) => {
    map[item.payableOrgId] = 1;
  });
  return Object.keys(map).length === 1;
}

// 判断是否都是同一个收款公司
function isSameReceivableOrg(arr) {
  const map = {};
  arr.forEach((item) => {
    map[item.receivableOrgId] = 1;
  });
  return Object.keys(map).length === 1;
}

export default {
  components: {},
  data() {
    return {
      // 付款登记
      paymentRegistrationVisible: false,
      paymentRegistrationModel: {},

      // 查看付款信息
      paymentInfoVisible: false,
      paymentInfoModel: {},

      // 查看收款信息
      collectionInfoVisible: false,
      collectionInfoModel: {},

      // 申请免收
      applyFreeVisible: false,
      applyFreeModel: {},

      // 确认收款
      confirmCollectionVisible: false,
      confirmCollectionModel: {},

      // 登记收款
      registerCollectionVisible: false,
      registerCollectionModel: {},

      // 登记付款(应收押金)
      depositRegistrationVisible: false,
      depositRegistrationModel: {},

      // 登记收款（应收押金）
      depositRegistrationReceiveVisible: false,
      depositRegistrationReceiveModel: {},

      // 查看申请免收
      checkApplyFreeVisible: false,
      checkApplyFreeModel: {},

      // 撤销收款
      cancelCollectionVisible: false,
      cancelCollectionModel: {},

      // 撤销付款
      cancelPaymentVisible: false,
      cancelPaymentModel: {},
      // 申请开票
      dialogVisible6: false,
      dialogModel6: {},

      // 查看发票信息（不是发票详情，发票信息是列表，列表点击发票号才进去发票详情）
      invoiceBillMsgVisible: false,
      invoiceBillMsgModel: {},

      TRADE_STATUS,
      BILL_STATUS,
    };
  },
  methods: {
    // 查看发票信息
    checkInvoiceBillMsg(row) {
      this.invoiceBillMsgModel = {
        title: '发票信息',
        data: row,
      };
      this.invoiceBillMsgVisible = true;
    },
    /**
     * 确认收款
     * @param {object | array<object>} row 需要登记收款的列表，可以为单项，可以为列表
     * @param {string} title
     * @param {object} resData 收款登记保存后返回的信息
     */
    confirmCollection(row, title, resData = {}) {
      const rows = Array.isArray(row) ? [...row] : [row];
      this.confirmCollectionModel = {
        data: {
          billData: rows,
          billPaymentId: resData.billPaymentId,
        },
        title,
      };
      this.confirmCollectionVisible = true;
    },
    /**
     * 登记收款
     * @param {object | array<object>} row 需要登记收款的列表，可以为单项，可以为列表
     * @param {string} title
     */
    registerCollection(row, title) {
      const rows = Array.isArray(row) ? [...row] : [row];
      this.registerCollectionModel = {
        data: {
          billData: rows,
        },
        title,
      };
      this.registerCollectionVisible = true;
    },
    /**
     * 登记付款（应付押金）
     * @param {object | array<object>} row 需要登记付款的列表，可以为单项，可以为列表
     * @param {string} type pay: 登记付款， revoke：撤销付款， watch： 查看付款信息
     */
    depositRegistration(row, type) {
      const rows = Array.isArray(row) ? [...row] : [row];
      this.depositRegistrationModel = {
        type,
        data: {
          billData: rows,
        },
      };
      this.depositRegistrationVisible = true;
    },
    /**
     * 申请免收
     * @param {object | array<object>} row 需要申请免收的列表，可以为单项，可以为列表
     * @param {string} title model title
     * @param {boolean} isPay 是否为付款账单,默认为false
     */
    applyFree(row, title, isPay = false) {
      const rows = Array.isArray(row) ? [...row] : [row];
      const billType = rows[0].billType;
      const changeId = rows[0].changeId;
      rows.forEach((item) => {
        item.isPay = isPay;
      });
      let changeType;
      if (`${billType}` === '100') {
        changeType = 'free_stock_fee';
      } else if (`${billType}` === '12') {
        changeType = 'free_break_fee';
      } else if (`${billType}` === '15') {
        changeType = 'free_test_fee';
      } else {
        changeType = 'free_overdue_fee';
      }

      this.applyFreeModel = {
        row: rows,
        type: 'edit',
        changeType,
        changeId,
        title,
      };
      this.applyFreeVisible = true;
    },
    /**
     * 付款登记
     * @param {object | array<object>} row 需要付款登记的应付款列表，可以为单项，可以为列表
     * @param {string} title dialog title
     */
    paymentRegister(row, title) {
      const rows = Array.isArray(row) ? [...row] : [row];
      this.paymentRegistrationModel = {
        data: {
          billData: rows,
        },
        title,
      };
      this.paymentRegistrationVisible = true;
    },
    /**
     * 开票申请
     * @param {object | array<object>} row 需要开票的账单列表，可以为单项，可以为列表
     * @param {boolean} isPay 是否付款的发票登记 付款的是弹窗 应收是提示后提交
     * @param {string} callbackName 操作成功后的执行方法名称
     */
    invoiceApply(row, isPay = true, callbackName) {
      if (isPay) {
        // 应付
        this.dialogModel6.title = this.$t('Common.com_minxins_apply_invoice');
        this.dialogModel6.row = row;
        this.dialogVisible6 = true;
      } else {
        // 应收
        // 1.应收列表中 发票抬头 是 付款方公司的 发票抬头
        // 2.invoiceClass发票类别：1-纸质发票
        // 3.invoiceType 开票类型： 2-增值税专用发票
        const rows = Array.isArray(row) ? [...row] : [row];
        const tips = this.$t('Common.com_minxins_apply_tips');

        this.$showConfirm(tips).then(() => {
          const partnerInvoiceId = rows[0].payableOrgId;
          const billIdList = rows.map(item => item.billId);
          const invoiceType = 1;
          const invoiceClass = 1;
          this.$postJSON(apis.invoiceMark, { partnerInvoiceId, billIdList, invoiceType, invoiceClass }, true).then(() => {
            this.$message({
              type: 'success',
              message: this.$t('Common.com_handle_success'),
            });
            if (callbackName) {
              this[callbackName](rows);
            } else if (this.getTableList) {
              this.getTableList(rows);
            }
          });
        });
      }
    },
    /**
     * 查看付款信息
     * @param {object} row 需要查看付款信息的应付款row
     * @param {string} title
     */
    checkPaymentInfo(row, title) {
      this.paymentInfoModel = {
        data: {
          billData: [row],
        },
        title,
      };
      this.paymentInfoVisible = true;
    },

    /**
     * 查看收款信息
     * @param {object} row 需要查看收款信息的应付款row
     * @param {string} title
     */
    checkCollectionInfo(row, title) {
      this.collectionInfoModel = {
        data: {
          billData: [row],
        },
        title,
      };
      this.collectionInfoVisible = true;
    },

    /**
     * 拒绝付款（撤销付款）;
     * @param {object} row 应付款row
     */
    cancelPayment(row) {
      this.cancelPaymentModel = {
        data: {
          billData: [row],
        },
      };
      this.cancelPaymentVisible = true;
    },

    /**
     * 检测权限
     * @param {object | array<object>} row 可以为单项，可以为列表
     * @param {string} auth 权限名称
     * 开票申请:INVOICE
     * 查看付款记录:CHECK_PAYMENT_INFO
     * 撤销付款:CANCEL_PAYMENT
     * 申请免收：APPLY_FREE
     * 查看收款记录:CHECK_COLLECTION_INFO
     * 查看申请免收信息：CHECK_APPLY_FREE_MSG
     * 确认收款 CONFIRM_COLLECTION
     * 登记收款：REGISTER_COLLECTION
     * 付款登记:PAY_REGISTER
     * 取消免收：CANCEL_FREE
     * 撤销收款：CANCEL_COLLECTION
     * 延期收款：DELAY_COLLECTION
     * 延期付款：DELAY_PAYMENT
     * 取消订单：CANCEL_ORDER
     * 开票记录: CHECK_INOVIE
     * @return {boolean} ret 是否有权限
     */
    checkAuth(row, auth) {
      let flag = true;
      const checkRule = ACTION_AUTH[auth];
      const rows = Array.isArray(row) ? row : [row];

      // 开票记录
      if (auth === 'CHECK_INOVIE') {
        // 账单类型不为押金
        let billTypeCheck = true;
        if (this.dicMap.bill_type && this.dicMap.bill_type.deposit) {
          billTypeCheck = !rows.some((item) => {
            const isDeposit = `${this.dicMap.bill_type.deposit}` === `${item.billType}`;
            return isDeposit;
          });
        }
        // invoiceTime
        const invoiceTimeCheck = !rows.some(item => !item.invoiceTime);
        if (!billTypeCheck || !invoiceTimeCheck) {
          return false;
        }
      }

      // 登记收款
      if (auth === 'REGISTER_COLLECTION') {
        const checkPayableOrg = isSamePaymentOrg(rows);
        if (!checkPayableOrg) {
          return false;
        }
      }

      // 登记付款
      if (auth === 'PAY_REGISTER') {
        const checkPayableOrg = isSameReceivableOrg(rows);
        if (!checkPayableOrg) {
          return false;
        }
      }

      // 申请免收
      if (['APPLY_FREE', 'APPLY_FREE_PAYMENT'].includes(auth)) {
        // billTradeState 11-免收完成  2-免收中 不可为免收
        const checkBillTradeState = !rows.some(item => [2, 11].includes(item.billTradeState));
        // 开票中或已开票时不可免收 1 -待开票 2 -开票中 3-已开票 注：查询时，参数为invoiceState，列表属性返回为invoiceStatus
        const checkInvoiceState = !rows.some(item => `${item.invoiceStatus}` !== '1');
        //  目前只允许用户选择逾期 / 违约 / 库存费账单 / 试用 且同一个付款公司才可点击此按钮申请免收;
        const checkBillType = !rows.some(item => !['12', '13', '100', '15'].includes(`${item.billType}`));
        const checkPayableOrg = auth === 'APPLY_FREE' ? isSamePaymentOrg(rows) : isSameReceivableOrg(rows);
        // 如果不是(逾期 / 违约 / 库存费账单)或者不是同一个付款公司或者不是待开票，则直接返回false；否则，则进入下面判断state
        if (!checkBillType || !checkPayableOrg || !checkInvoiceState || !checkBillTradeState) {
          return false;
        }
      }

      // 取消订单
      if (auth === 'CANCEL_ORDER') {
        const isLockBill = rows.some(item => item.isLockBill);
        // 如果是lockBill，那么则返回false.否则，进入billTradeState判断
        if (isLockBill) {
          return false;
        }
      }

      // 开票申请
      if (auth === 'INVOICE') {
        // invoiceWaitState 账单待开票状态 1-待提交 2-已提交
        // 开票金额: paymentAmount -invoiceAmount -lockInvoiceAmount(账单金额 - 已开票金额 - 锁定开票金额)
        // 账单待开票状态-待提交  && 开票金额 > 0  && 账单类型不为押金 && 账单状态不为（已免收，已关闭）&& 同一个付款公司

        // 账单类型不为押金
        let billTypeCheck = true;
        if (this.dicMap.bill_type && this.dicMap.bill_type.deposit) {
          billTypeCheck = !rows.some((item) => {
            const isDeposit = `${this.dicMap.bill_type.deposit}` === `${item.billType}`;
            return isDeposit;
          });
        }

        // 账单状态不为（已免收，已关闭）
        const billTradeStateCheck = !rows.some(item => [TRADE_STATUS.TRADE_CLOSE.val, TRADE_STATUS.TRADE_FREE.val].includes(item.billTradeState));

        return (
          billTradeStateCheck
          // 账单类型不为押金
          && billTypeCheck
          // 账单待开票状态-待提交
          && !rows.some(item => item.invoiceWaitState !== 1)
          // 开票金额 > 0
          && !rows.some((item) => {
            const { paymentAmount = 0, invoiceAmount = 0, lockInvoiceAmount = 0 } = item;
            const ret = paymentAmount - invoiceAmount - lockInvoiceAmount <= 0;
            return ret;
          })
          // 同一个付款公司
          && isSamePaymentOrg(rows)
        );
      }

      // 撤销收款 交易完成 &  账单不曾提交开票,已经开票 => ( 已开票金额  = 锁定开票金额 = 0)
      if (auth === 'CANCEL_COLLECTION') {
        const hasFaultMoney = rows.some((item) => {
          const { invoiceAmount = 0, lockInvoiceAmount = 0 } = item;
          const ret = !(invoiceAmount === 0 && lockInvoiceAmount === 0);
          return ret;
        });
        if (hasFaultMoney) {
          return false;
        }
      }

      // // 撤销免收
      // if (auth === 'CANCEL_FREE') {
      //   return !rows.some(item => !item.changeId);
      // }

      // 延期收款/延期付款
      if (['DELAY_COLLECTION', 'DELAY_PAYMENT'].includes(auth)) {
        // 目前只允许用户选择租赁账单才可点击此按钮
        const checkBillType = !rows.some(item => `${item.billType}` !== '10');
        // 延期付款: 选中的多个账单都是租赁账单且是同一个收款公司
        const checkPayableOrg = isSameReceivableOrg(rows);
        // 如果不是租赁账单或者不是同一个付款公司，则直接返回false；否则，则进入下面判断state
        if (!checkBillType || !checkPayableOrg) {
          return false;
        }
      }

      if (checkRule) {
        rows.forEach((obj) => {
          if (checkRule.tradeStatus && checkRule.tradeStatus.length) {
            if (!checkRule.tradeStatus.includes(obj.billTradeState) && !checkRule.tradeStatus.includes(obj.tradeState)) {
              flag = false;
            }
          }
          if (checkRule.billStatus && checkRule.billStatus.length) {
            if (!checkRule.billStatus.includes(obj.billInvoiceState)) {
              flag = false;
            }
          }
        });
      }

      return flag;
    },
    // 获取紧急天数
    getUrgent(row) {
      const { billPaymentTime } = row;
      if (billPaymentTime) {
        const billPaymentTimeMs = new Date(this.$momentElLocal(billPaymentTime)).getTime();
        const curMs = new Date().getTime();
        const diff = Math.round((billPaymentTimeMs - curMs) / (24 * 3600 * 1000));
        return diff;
      }
      return '';
    },
    // 获取紧急天数显示文本
    getUrgentView(row) {
      const num = this.getUrgent(row);
      if (typeof num === 'number') {
        if (num >= 0) {
          return [num, this.$t('Common.com_day')].join('');
        } else {
          return this.$t('Common.com_minxins_expire');
        }
      }
      return '-';
    },
    /**
     * 将termNum转为数组
     * @param {string} termNum
     * @return {array} ret
     */
    formatTermNum(termNum) {
      if (!termNum) {
        return [];
      }
      // 是否为纯数字的字符串
      const testPureNum = /^\d+$/;
      // 是否为 1-3 格式的字符串
      const testRangeNum = /^\d+\-\d+$/;
      if (testPureNum.test(termNum)) {
        return [termNum, termNum];
      }
      if (testRangeNum.test(termNum)) {
        return termNum.split('-');
      }
      return [];
    },

    /**
     * 追加请求数据
     * @param {Object} reqData 请求数据
     * @param {String} menuCode 当前页面对应的code
     * @returns {Object} ret return data
     * receive_deposit - 应收押金; receive_bill - 应收订单;
     * receive_order - 应收账单; receive_refund - 应收退款;
     * pay_refund - 应退租金; pay_order - 应付账单；
     * pay_bill - 应付订单；pay_deposit - 应付押金;
     */
    appendReqListData(reqData, menuCode) {
      const ret = {
        ...reqData,
        onlySaleMan: false,
        loadRes: this.$route.path,
      };

      const menuRoleBoList = getDefault('menuRoleBoList', []);

      const item = menuRoleBoList.find(obj => obj.menuCode === menuCode);

      if (item && item.roleCodeList && item.roleCodeList.length === 1) {
        if (item.roleCodeList[0] === 'SYS_ROLE_SM') {
          ret.onlySaleMan = true;
        }
      }

      return ret;
    },
  },
  mounted() {
    this.getDicMap('bill_type', null);
  },
};
